import React, { useEffect } from 'react';
import { useRopeTypeContext } from 'src/contexts/rope-type.context';
import { actionTypes } from 'src/ducks/rope-type.duck';
import { getRopeTypeStatus } from 'src/selectors/rope-type.selector';
import RopeSizeConductorView from './rope-size-conductor-list.view';

const RopeSizeConductor: React.FC = () => {
  const { state, actions } = useRopeTypeContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <RopeSizeConductorView
      loading={getRopeTypeStatus(state, actionTypes.ROPE_TYPE_FETCH).fetching}
      data={state.list}
    />
  );
};

export default RopeSizeConductor;
